import { mode } from '@/helpers/enum';
import { identityTypeEnum, partyTypeEnum } from '@/modules/bankruptcy/helpers/enum';

export const initialData = () => ({
  currentStep: 0,
  isPledged: false,
  attachments: [],
  requestAttachments: [],
  requiredAttachmentTypes: [],
  attachmentTypes: [],
  mainRequest: {},
  submittedRequestInfo: { mode: mode.new },
  requestApplicant: {},
  secretary: {
    typeId: partyTypeEnum.person,
    identityTypeId: identityTypeEnum.nationalId,
    mode: mode.new,
  },
  creditor: {
    typeId: partyTypeEnum.person,
    mode: mode.new,
  },
  activities: {},
  debtor: {
    isOrganizedEntity: false,
    isSpecifiedOrganization: false,
    mode: mode.new,
  },
  attorneyDetails: {},
});

export default {
  isMainRequestLoading: false,
  currentStep: initialData().currentStep,
  isPledged: initialData().isPledged,
  mainRequest: initialData().mainRequest,
  submittedRequestInfo: initialData().submittedRequestInfo,
  requestApplicant: initialData().requestApplicant,
  secretary: initialData().secretary,
  activities: initialData().activities,
  debtor: initialData().debtor,
  creditor: initialData().creditor,
  attachments: { data: [] },
  requestAttachments: [],
  requiredAttachmentTypes: [],
  attachmentTypes: [],
  auditConfirmations: {},
  replies: [],
  attorneyDetails: initialData().attorneyDetails,
  currentUser: {},
};
